import { io } from "socket.io-client";

export const socket = io("https://easy-market.kahero.uz/", {
  autoConnect: false,
  path: "/admin-api/socket.io",
  extraHeaders: {
    Authorization: localStorage.getItem("token") || "",
  },
});
